function addSpace(nStr) {
    nStr += '';
    var x = nStr.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ' ' + '$2');
    }
    return x1 + x2;
}

$('#month').ionRangeSlider({
    type: "single",
    min: 0,
    max: 60,
    step: 1,
    grid: true,
    grid_num: 5,
    from_min: 1,
    hide_min_max: true,
    from: 60,
    postfix: $('#month').data('suffix'),
    skin: "round",
});

$('#car_min_percent').ionRangeSlider({
    type: "single",
    min: 10,
    max: 90,
    step: 5,
    grid: true,
    grid_num: 8,
    from_min: 1,
    hide_min_max: true,
    from: 20,
    postfix: $('#car_min_percent').data('suffix'),
    skin: "round",
});


var carCostValue = $('#car_cost');

if (carCostValue.length > 0) {
    carCostValue.val(addSpace(Number(carCostValue.val().replace(/\s+/g, ''))));
}

carCostValue.on('input', function() {
    calculate2();
});

$('#car_min_percent').on('input', function() {
    calculate2();
});

var depositeValue = $('#deposit');
depositeValue.val(addSpace(depositeValue.val()))

function calculate2 () {
    var carCost = Number(carCostValue.val().replace(/\s+/g, ''));
    carCostValue.val(addSpace(carCost));
    var month = $('#month').val();
    var P = 1.6 / 365;
    var t = Math.pow((1 + P), (365 / 12 * month));
    var deposite = carCost * ($('#car_min_percent').val() / 100);
    var rentPerDay = (P + (P / (t - 1)));
    var result = rentPerDay * (carCost - deposite);
    $('#price_day').val(addSpace(Math.round(result)));
    $('#deposit').val(addSpace(Math.round(deposite)));
}


$('#month').change(function() {

    calculate2()

});

